module.exports = "https://coursera_assets.s3.amazonaws.com/images/6bb3e56bee1039824ca0e77ca81fbaa7.png";